"use strict";require("core-js/modules/es.array.for-each");require("core-js/modules/es.parse-int");exports.__esModule = true;exports.secToHms = secToHms;exports.secToHms_str = secToHms_str;exports.secToHms_arr = secToHms_arr;exports.secToHms_arrStr = secToHms_arrStr;

var _fmt = require("../fmt");







var keys = ['h', 'm', 's'];




/**
                             * Переводит секунды в часы, минуты, секунды
                             *
                             *
                             * @param {number} seconds
                             * @example
                             * secToHms( 123456 ) // { h: 10, m: 17, s: 36 }
                             * @returns {{ h: number, m: number, s: number }}
                             * @memberof Time
                             */
function secToHms(seconds) {
  var sec = parseInt(seconds);

  var h = Math.floor(sec / 3600) % 24;
  var m = Math.floor(sec / 60) % 60;
  var s = sec % 60;

  return { h: h, m: m, s: s };
}

/**
   * Переводит секунды в часы, минуты, секунды
   * Возвращает объект с форматированными строками
   *
   *
   * @param {number} seconds
   * @example
   * secToHms_str( 123 ) // { h: '00', m: '02', s: '03' }
   * @returns {{ h: string, m: string, s: string }}
   * @memberof Time
   */
function secToHms_str(seconds) {
  var d = secToHms(seconds);
  var result = {};
  keys.forEach(function (key) {
    result[key] = (0, _fmt.toTensStr)(d[key]);
  });
  return result;
}

/**
   * Возвращает массив с часами, минутами, секундами
   *
   *
   * @param {number} seconds
   * @example
   * secToHms_arr( 123456 ) // [ 10, 17, 36 ]
   * @returns {[ number, number, number ]}
   * @memberof Time
   */
function secToHms_arr(seconds) {
  var d = secToHms(seconds);
  return [d.h, d.m, d.s];
}

/**
   * Возвращает массив с форматированными часами, минутами, секундами
   *
   *
   * @param {number} seconds
   * @example
   * secToHms_arrStr( 123 ) // [ '00', '02', '03' ]
   * @returns {[ string, string, string ]}
   * @memberof Time
   */
function secToHms_arrStr(seconds) {var _secToHms_arr =
  secToHms_arr(seconds),h = _secToHms_arr[0],m = _secToHms_arr[1],s = _secToHms_arr[2];
  return [(0, _fmt.toTensStr)(h), (0, _fmt.toTensStr)(m), (0, _fmt.toTensStr)(s)];
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/convert/secToHms.js
// module id = 627
// module chunks = 0